import { Building2, Radio, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const MasterData = () => {
  const navigate = useNavigate();

  const modules = [
    {
      title: "Organizations",
      description: "Manage organization master data.",
      icon: Building2,
      route: "/admin/master-data/organizations",
    },
    {
      title: "Sources",
      description: "Manage source master data.",
      icon: Radio,
      route: "/admin/master-data/sources",
    },
  ];

  return (
    <div className="p-2 space-y-4">
      {/* HEADER */}
      <div>
        <h1 className="text-2xl font-bold text-slate-800">Master Data</h1>

        <p className="text-slate-500 mt-1">
          Manage all system master data from one place.
        </p>

        <div className="mt-4 inline-flex items-center px-4 py-2 rounded-xl bg-blue-50 border border-blue-100">
          <span className="text-sm font-medium text-blue-700">
            Available Modules: {modules.length}
          </span>
        </div>
      </div>

      {/* MODULES */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {modules.map((module) => {
          const Icon = module.icon;

          return (
            <button
              key={module.title}
              onClick={() => navigate(module.route)}
              className="
          bg-white border border-slate-200 rounded-3xl
          shadow-sm p-6 text-left
          hover:shadow-lg hover:-translate-y-1
          transition-all duration-200
        "
            >
              <div className="h-14 w-14 rounded-2xl bg-blue-50 text-blue-600 flex items-center justify-center">
                <Icon size={24} />
              </div>

              <h3 className="mt-5 text-lg font-semibold text-slate-800">
                {module.title}
              </h3>

              <p className="mt-2 text-sm text-slate-500">
                {module.description}
              </p>

              <div className="mt-5 text-primary font-medium text-sm">
                View Records →
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MasterData;
